import { Navigate } from 'react-router';
import { useFeatureFlags } from '~/helpers/FeatureFlagsContext.tsx';
import SupervisorAdministrationPage from './SupervisorAdministrationPage.tsx';
import { getSupervisorAdministrationPageConfig } from './config.ts';
import type { TSupervisorAdministrationPageKey } from './types.ts';
import { useSupervisorAdministrationAccess } from './useSupervisorAdministrationAccess.ts';
import { useGuaranteesSupervisorSegmentsGroup } from './useGuaranteesSupervisorSegmentsGroup.ts';

type TSupervisorAdministrationRoutePageProps = {
  pageKey: TSupervisorAdministrationPageKey;
};

const SupervisorAdministrationRoutePage = ({
  pageKey,
}: TSupervisorAdministrationRoutePageProps) => {
  const { isGuaranteesEnabled } = useFeatureFlags();
  const {
    hasSupervisorAdministrationAccess,
    isSupervisorAdministrationAccessLoading,
  } = useSupervisorAdministrationAccess(pageKey);
  const pageConfig = getSupervisorAdministrationPageConfig(pageKey);
  const {
    addingSectionId,
    deletingUserId,
    handleAddUser,
    handleDeleteUser,
    handleSearchSubmit,
    isLoading: isSegmentsLoading,
    sections,
  } = useGuaranteesSupervisorSegmentsGroup({
    groupKey: pageKey,
    enabled: hasSupervisorAdministrationAccess,
  });

  if (
    !isGuaranteesEnabled ||
    (!hasSupervisorAdministrationAccess && !isSupervisorAdministrationAccessLoading)
  ) {
    return <Navigate to="/covenants/manager/segments" replace />;
  }

  return (
    <SupervisorAdministrationPage
      titleSuffix={pageConfig.titleSuffix}
      subtitle={pageConfig.subtitle}
      sections={sections}
      isLoading={isSupervisorAdministrationAccessLoading || isSegmentsLoading}
      addingSectionId={addingSectionId}
      deletingUserId={deletingUserId}
      useServerSearch
      onSearchSubmit={handleSearchSubmit}
      onAddUser={handleAddUser}
      onDeleteUser={handleDeleteUser}
    />
  );
};

export const UsapokAdministrationPage = () => (
  <SupervisorAdministrationRoutePage pageKey="usapok" />
);

export const UmvnAdministrationPage = () => (
  <SupervisorAdministrationRoutePage pageKey="umvn" />
);

export const UoAdministrationPage = () => (
  <SupervisorAdministrationRoutePage pageKey="uo" />
);

export const UdbtfAdministrationPage = () => (
  <SupervisorAdministrationRoutePage pageKey="udbtf" />
);
